import React from 'react';
import PropTypes from 'prop-types';
import * as AppActions from '../../actions/AppActions';
import { Checkbox, Tooltip } from '@paypalcorp/pp-react';

const AnonymousCheckbox = ({
  content,
  optInStatus,
  handleAnonymousDonationChange,
}) => {
  const handleChange = (event) => {
    const isChecked = event.target.checked,
      checkboxStatus = isChecked ? 'checked' : 'unchecked';

    AppActions.changeAnonymousStatus({
      anonymousStatus: checkboxStatus,
    });

    handleAnonymousDonationChange(isChecked);
  };

  return (
    <div className="anonymous-checkbox-wrapper">
      <Checkbox
        className="anonymous-checkbox"
        id="anonymous-checkbox"
        data-testid="anonymous-checkbox"
        name="anonymousCheckbox"
        label={content?.label}
        value={optInStatus}
        onChange={handleChange}
        checked={optInStatus}
        labelIcon={
          content?.tooltip && (
            <Tooltip
              name="anonymous-checkbox-tooltip"
              description={content?.tooltip}
            />
          )
        }
      />
    </div>
  );
};

AnonymousCheckbox.propTypes = {
  content: PropTypes.object,
  optInStatus: PropTypes.bool,
  handleAnonymousDonationChange: PropTypes.func,
};

export default AnonymousCheckbox;
